import {Observable} from 'rxjs';
import {withLatestFrom} from 'rxjs/operators';

import createPlaybackStatusStream from '../../../Shared/Streams/createPlaybackStatusStream';
import PlaybackStatus             from '../../../State/Stores/Playback/Constants/PlaybackStatus';
import Playback                   from '../../../State/Stores/Playback/Playback';

const createPlaybackStatusWithPlaybackStream = (
    playbackStoreUpdate$: Observable<Playback>
): Observable<[PlaybackStatus, Playback]> =>
    createPlaybackStatusStream(playbackStoreUpdate$)
        .pipe(
            withLatestFrom(playbackStoreUpdate$)
        );

export default createPlaybackStatusWithPlaybackStream;